<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("SystemStatus") }}</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg">
      <div class="panel panel-filled">
        <div class="panel-body">
          <p>
            The System Status page is a monitoring tool designed by our team
            that provides near real-time information
          </p>
        </div>

        <div class="panel-body">
          <table class="table table-condensed">
            <thead>
              <tr>
                <th>{{ $t("Assets") }}</th>
                <th>{{ $t("Status") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="c in getCurrency" v-bind:key="c._id">
                <td>
                  <img
                    :src="require(`@/assets/tokens/${c.coin}.png`)"
                    class="coin m-l-sm"
                  /><br />
                  {{ c.name }} ({{ c.coin }})<br />
                  <div v-if="getCoins[c.coin]">
                    <span class="font-bold c-white"
                      >$ {{ getCoins[c.coin].last_price }}</span
                    >
                    (
                    <span
                      href="#"
                      class="text-muted"
                      v-if="getCoins[c.coin].change / 1 == 0"
                      >0.00%</span
                    >
                    <span
                      href="#"
                      class="text-buy"
                      v-else-if="getCoins[c.coin].change / 1 > 0"
                      >+{{ getCoins[c.coin].change }}%</span
                    >
                    <span href="#" class="text-sell" v-else
                      >{{ getCoins[c.coin].change }}%</span
                    >)
                  </div>
                  <a v-bind:href="c.website" target="_blank">Website</a><br />
                  <a v-bind:href="c.explorer" target="_blank">
                    Explorer
                  </a>
                </td>
                <td>
                  <div>
                    Status: <span class="text-accent">{{ c.status }}</span>
                  </div>
                  <div v-if="c.type == 'ENABLED' || c.type == 'DEPOSIT_ONLY'">
                    Deposit: <span class="text-success">ENABLED</span>
                  </div>
                  <div v-else>
                    Deposit: <span class="text-danger">DISABLED</span>
                  </div>
                  <div v-if="c.type == 'ENABLED' || c.type == 'WITHDRAW_ONLY'">
                    Withdrawal: <span class="text-success">ENABLED</span>
                  </div>
                  <div v-else>
                    Withdrawal: <span class="text-danger">DISABLED</span>
                  </div>
                  Min. Deposit:
                  <span class="text-accent">{{ c.min_deposit }}</span
                  ><br />
                  Confirmations:
                  <span class="text-accent">{{ c.deposit_confirm }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["getCurrency", "getCoins"])
};
</script>

<style scoped>
.coin {
  width: 32px;
}
</style>
